export default __webpack_public_path__ + "static/media/trialDesign.bc9a435b.png";